import { useEffect, useState } from 'react'

export default function useAsync<T> (
  fn: null | (() => Promise<T>),
  options?: { clearOnUpdate?: boolean }
): null | Error | T {
  const [result, setResult] = useState<null | Error | T>(null)
  const clearOnUpdate = options?.clearOnUpdate ?? false

  useEffect(() => {
    if (fn === null) {
      return
    }
    const changedRef = { current: false }
    function setResultIfNotYetChanged (result: Error | T): void {
      if (changedRef.current) {
        console.debug(
          '[useAsync] Ignoring response since fn has changed since',
          result
        )
        return
      }
      setResult(result)
    }
    fn().then(setResultIfNotYetChanged).catch(setResultIfNotYetChanged)
    return () => {
      changedRef.current = true
      if (clearOnUpdate) {
        setResult(null)
      }
    }
  }, [fn])

  return result
}
